export const cms = {
	apiUrl: 'https://tocafan.nl/contentful',
};